import(/* webpackMode: "eager" */ "/workspace/frontend/app/components/banner/ctaBanner.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/app/components/footer/footerSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroHomeClient"] */ "/workspace/frontend/app/components/heros/heroHomeClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroPeople"] */ "/workspace/frontend/app/components/heros/heroPeople.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandscapeAsset"] */ "/workspace/frontend/app/components/layoutModules/LandscapeAsset.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RelationBlockModule"] */ "/workspace/frontend/app/components/layoutModules/RelationBlockModule.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/app/components/layoutModules/Slider.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/app/components/layoutModules/TextBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextTriad"] */ "/workspace/frontend/app/components/layoutModules/TextTriad.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkElement"] */ "/workspace/frontend/app/components/link/link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageContent"] */ "/workspace/frontend/app/components/page/pageContent.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/app/components/Revealer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionDetailHero"] */ "/workspace/frontend/app/components/solutionDetail.tsx/SolutionDetailHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionDetailText"] */ "/workspace/frontend/app/components/solutionDetail.tsx/SolutionDetailText.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/app/components/structuredData/StructuredData.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/app/components/Video.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/app/provider/LenisScrollProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/frontend/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
